import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
import { ITraceEventMarker } from '@faire/web/common/pete/TraceEventTracker';

export const eventKey = 'search-product_batch-view';

/**
 * Search page product batch view on scroll
 */
export function trackSearchProductBatchView(
  customParameterToken: string,
  customParameterToken2: string
): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
    parameters: { customParameterToken, customParameterToken2 },
  });
}
